module.exports = __webpack_public_path__ + "img/graphIcon_Inactive.096f918b.png";